import React from 'react'
import CartComponent from '../Components/Cart/Cart'

const Cart = () => {
  return (
    <CartComponent />
  )
}

export default Cart